<template>
  <div class="section-item books">
    <span v-if="item.badge" class="badgeText">{{ item.badge }}</span>
    <div v-if="item.discount > 0" class="discount-badge">
      <span>{{ item.discount }}</span>
      <span v-if="item.discount_type == 'Percent'">%</span>
      <span v-else class="taka-off">Tk.</span>
      <div>OFF</div>
    </div>
    <a :href="`${baseUrl}book/${item.id}`">
      <ProductImage :image="item.image" />
      <ProductNameH4 :product_name="item.product_name" />
      <span
        v-for="(author, index) in item.authors"
        v-bind:key="index"
        class="writer-name"
      >
        {{ author.author_name }}
        <span v-if="index + 1 < item.authors.length">, </span>
      </span>
      <div class="item-price">
        <span v-if="item.discount > 0" class="item-regular-price">
          ৳{{ item.orginal_price }}
        </span>
        <span>
          ৳{{ item.discount > 0 ? item.price : item.orginal_price }}
        </span>
      </div>
    </a>
    <ItemHoverButtons :item="item"/>
  </div>
</template>

<script>
import ProductImage from './ProductImage.vue';
import ProductNameH4 from './ProductNameH4.vue';
import ItemHoverButtons from './ItemHoverButtons.vue';

export default {
  name: 'ProductCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    ProductImage,
    ProductNameH4,
    ItemHoverButtons
  }
};
</script>
